// lib
import { batch } from "react-redux";
// src
import back from "services/plannings";
import { login } from "services/ms365";
import { fetchEnableds } from "actions/events/thunks";
import * as sync from "./index";

export const loginAndKeepPath = (pathname) => async (dispatch) => {
  dispatch(sync.setRedirect(pathname));
  await login();
};

export const fetchBackToken = (token) => async (dispatch, getState) => {
  await back.request(
    { resource: "/token", method: "POST", body: JSON.stringify({ token }) },
    dispatch,
    getState,
    () => dispatch(sync.backTokenRequest()),
    (json) => {
      batch(() => {
        const { identity, token: backToken, ...state } = json;
        dispatch(sync.backTokenSuccess({ identity, token: backToken }));
        dispatch(sync.userStateSuccess(state));
        dispatch(fetchEnableds());
      });
    },
    (status) => dispatch(status === 401 ? sync.authRejected() : sync.authAborted()),
  );
};

export const fetchUserState = () => async (dispatch, getState) => {
  await back.request(
    "/my/state",
    dispatch,
    getState,
    () => dispatch(sync.userStateRequest()),
    (json) => {
      batch(() => {
        dispatch(sync.userStateSuccess(json));
        dispatch(fetchEnableds());
      });
    },
    () => dispatch(sync.userStateFailure()),
  );
};
